<template>
  <component
    :is="config.isScroll ? ElScrollbar : 'div'"
    :class="{ 'new-detail-item': true }"
    :style="{
        height: typeof config.height == 'number' ? config.height + 'px' : 'auto',
      }"
  >
    <h6 class="new-detail-item-title">{{ localizedPage.title }}</h6>
    <div
      class="new-detail-item-info"
    >{{ $t('texts.createTime') }}: {{ page.onlineTime }} {{ $t('texts.readAmount') }}: {{ page.readNum }}</div>
    <div class="new-detail-item-cont" v-html="localizedPage.content"></div>
    <div class="new-detail-item-btn" v-if="config.isShowBackBtn">
      <el-button size="small" @click="getBack">{{ $t('texts.backPrevPage')  }}</el-button>
    </div>
  </component>
</template>
  
<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useRoute } from "#app"; // Nuxt 3 相关 hook
import { getActiveListFormPlatform, getArticleDetail } from "@/api";
import { getSassmallArticleDetail, getSassmallArticleByUrl, readSassmallArticle } from "~/sassmall/api/content";
import { isSassmallResponseSuccess } from "~/sassmall/api/client";
import { ElButton ,ElScrollbar } from "element-plus";
import { localizeI18nRecord } from "~/utils/i18nJson.js";
 

// 提供组合式 API 的 props
const props = defineProps({
  allArcListMap: {
    type: Object,
    default: () => ({})
  },
  currentElementIndex: {
    type: Array,
    default: () => []
  },
  idx: {
    type: Number,
    default: -1
  },
  parentKeys: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: true
  },
  config: {
    type: Object
  }
});

// 响应式数据
const page = ref({});
const { locale } = useI18n();
const localizedPage = computed(() =>
  localizeI18nRecord(page.value, ["title", "content"], locale.value) || {},
);

// 获取页面数据

const route = useRoute();
const detailId = computed(() => {
  return props.config.isGetRouteId
    ? (route.query && (route.query.detailId || route.query.url)) || ""
    : props.config.value;
});

const isArticle = (article) => {
  return (
    article &&
    typeof article === "object" &&
    !Array.isArray(article) &&
    ("id" in article || "title" in article || "content" in article)
  );
};

async function loadArticleDetail(id) {
  page.value = {};

  try {
    let articleId = String(id || "").trim();
    if (!articleId && (props.config.categoryId || props.config.themeId)) {
      const listResponse = await getActiveListFormPlatform({
        categoryId: props.config.categoryId,
        topicId: props.config.themeId,
        pageNo: 0,
        pageSize: 1,
      });
      articleId = String(listResponse?.data?.dataList?.[0]?.id || "").trim();
    }
    if (!articleId) return;

    let article;
    try {
      const response = props.config.isGetRouteId && route.query?.url
        ? await getSassmallArticleByUrl(articleId)
        : await getSassmallArticleDetail(articleId);
      if (isSassmallResponseSuccess(response) && response.data) {
        article = {
          ...response.data,
          coverPic: response.data.coverUrl,
          onlineTime: response.data.publishTime,
          readNum: response.data.readCount,
        };
        void readSassmallArticle(articleId).catch(() => {});
      }
    } catch (error) {
      console.warn("Sassmall 文章详情接口失败，尝试旧接口", error);
    }
    try {
      if (!isArticle(article)) {
        const response = await getArticleDetail({ id: articleId });
        article = response?.data?.data || response?.data;
      }
    } catch (error) {
      console.error("获取文章详情接口失败，尝试使用文章列表接口兜底", error);
    }

    if (!isArticle(article)) {
      const listResponse = await getActiveListFormPlatform({
        id: articleId,
        pageNo: 0,
        pageSize: 1,
      });
      article = listResponse?.data?.dataList?.[0];
    }

    if (isArticle(article)) {
      page.value = article;
    }
  } catch (error) {
    console.error("获取文章详情失败，文章列表接口兜底也失败", error);
  }
}

onMounted(() => {
  watch([detailId, locale], ([id]) => loadArticleDetail(id), { immediate: true });
});

// 计算属性
const currentElementIndexStr = computed(() => {
  return props.currentElementIndex.length
    ? props.currentElementIndex.join("x")
    : "";
});

// 方法
const getBack = () => {
  history.go(-1);
};
</script>
  
<style scoped>
.new-detail-item {
  padding: 10px;
}

.new-detail-item .new-detail-item-title {
  font-size: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.new-detail-item .new-detail-item-info {
  font-size: 12px;
  padding: 10px 0;
  color: #999;
}

.new-detail-item .new-detail-item-cont {
  font-size: 14px;
  padding: 10px 0 10px;
}

.new-detail-item .new-detail-item-cont :deep(img)  {
  display: block;
  max-width: 100%;
}

.new-detail-item .new-detail-item-btn {
  padding: 10px 0;
  text-align: center;
}
</style>
